import React from "react";

import { HeaderImageContainer, HeaderImageContainerProps } from "./styles";

interface HeaderImageProps extends HeaderImageContainerProps {
  image?: string;
  alt?: string;
}

export const HeaderImage: React.FC<HeaderImageProps> = ({ children, ...rest }) => (
  <HeaderImageContainer {...rest}>{children}</HeaderImageContainer>
);
